import { ChangeDetectionStrategy, Component } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { ToastService } from '../toast.service';

@Component({
  selector: 'grid-ui-toast-container',
  templateUrl: './toast-container.component.html',
  styleUrls: ['./toast-container.component.scss'],
  host: { class: 'toast-container' },
  standalone: false,
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class ToastContainerComponent {
  constructor(
    public toastService: ToastService,
    private sanitizer: DomSanitizer,
  ) {}

  public sanitizeHtml(html: string): SafeHtml {
    // nosemgrep: typescript.angular.security.audit.angular-domsanitizer.angular-bypasssecuritytrust
    return this.sanitizer.bypassSecurityTrustHtml(html);
  }
}
